import { render } from "./Main.vue?vue&type=template&id=4fdafeee"
const script = {}
script.render = render

export default script